module.exports = __webpack_public_path__ + "static/media/wbtc.ec9921c8.svg";